import styled from 'styled-components';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';
import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const LeadContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};
`;

export const Description = styled(RichTextContent)`
    margin-bottom: ${getPurpurSpacing('100')};
`;
